const STORAGE_KEY = "credita_accountant_partnership";

export const readAccountantPartnership = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

export const saveAccountantPartnership = (payload) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
};

export const clearAccountantPartnership = () => {
  localStorage.removeItem(STORAGE_KEY);
};
